import React from "react";

const SidebarContext = React.createContext(false);

export default SidebarContext;